import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import CustomTable from "../../components/CustomTable";
import dummyimage from "../../../images/dummyimage.jpeg";
import { get } from "../../../store/actions/CommonActions";
import { GET_APPFEED } from "../../../store/actions/ActionTypes";
import { getImageUrl } from "../Artist/ArtistAvatar";
import { getAppFeedStatus, getAppFeedStatusStyles } from "../../../utils/functions/date";
export const AppFeedBanner = ({ image }) => {
  return (
    <div className="show-block-ui">
      <div className="show-banner-image">
        <img src={image ? getImageUrl(image) : dummyimage} lazyload />
      </div>
    </div>
  );
};


const APP_FEED_SAVE_STATE_KEY = "fromAppFeedSave";

const AppFeed = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const fromAppFeedSave = Boolean(location.state?.[APP_FEED_SAVE_STATE_KEY]);

  useEffect(() => {
    if (!fromAppFeedSave) return;
    navigate("/app-feed", { replace: true, state: {} });
  }, [fromAppFeedSave, navigate]);

  const columns = [
    {
      label: "#",
      render: (row, index, currentPage = 1, pageSize = 10) => (
        <span>{(currentPage - 1) * pageSize + index + 1}</span>
      ),
    },
    {
      label: "Title",
      render: (row) => <span>{row.title ?? "-"}</span>
    },
    {
      label: "Image",
      render: (row, index) => <span>{AppFeedBanner({ image: row?.banner })}</span>,
    },
    {
      label: "Visible From",
      render: (row) => <span>{new Date(row.postStartDate).toLocaleDateString("en-GB")}</span>
    },
    {
      label: "Visible until",
      render: (row) => <span>{new Date(row.postEndDate).toLocaleDateString("en-GB")}</span>
    },
    {
      label: "Status",
      render: (row) => {
        const status = getAppFeedStatus(row.postStartDate, row.postEndDate);
        const styles = getAppFeedStatusStyles(status);

        return (
          <span
            className="px-2 py-1 rounded"
            style={{
              color: styles.color,
              backgroundColor: styles.background,
              border: styles.border,
              fontSize: "12px",
              fontWeight: "500",
              display: "inline-block",
              minWidth: "70px",
              textAlign: "center"
            }}
          >
            {status}
          </span>
        );
      },
    },
  ];

  const getHook = (data) => {
    return (dispatch) => {
      dispatch(get("app-feed", data, GET_APPFEED));
    };
  };

  return (
    <CustomTable
      title="APP FEED"
      columns={columns}
      getHook={getHook}
      store={"appfeed"}
      addBtnTitle="Add New Post"
      deleteHook={"app-feed"}
      startOnPageOne={fromAppFeedSave}
    />
  );
};

export default AppFeed;
